import { WorkshopWithSessions } from '../../../workshop-session/components/WorkshopGroup';
import ClickableWorkshopCard from '../ClickableWorkshopCard';
import WorkshopCard3 from '../WorkshopCard3';
import WorkshopSessionsCard from '../WorkshopSessionsCard';
import VodCard from '../variants/VodCard';
import WorkshopCard3dx from '../variants/WorkshopCard3dx';
import WorkshopImageOverlayCard from '../variants/WorkshopImageOverlayCard';
import WorkshopOvhCard from '../variants/WorkshopOvhCard';
import WorkshopTemplate from '../variants/WorkshopTemplate';
import { AccordionCard } from '../variants/accordion';

export const variants: Record<string, any> = {
  'card': WorkshopCard3,
  'clickable': ClickableWorkshopCard,
  '3ds': WorkshopCard3dx,
  'template': WorkshopTemplate,
  'image-overlay': WorkshopImageOverlayCard,
  'ovh': WorkshopOvhCard,
  'cardWithSessions': WorkshopSessionsCard,
  'simpleSessions': WorkshopWithSessions,
  'vod': VodCard,
  'accordion': AccordionCard,
};
